import { useEffect, useRef } from 'react';
import { OverlayManager } from './OverlayManager';
/**
 * Реакт-хук, реализующий закрытие всплывающих компонентов,
 * таких как `Popup`, `Modal`, `Tooltip` и `MessageBox` в нужном порядке,
 * по умолчанию используется внутри `Popup` и `Modal`.
 */
export function useOverlay(options) {
    var visible = options.visible, onClose = options.onClose, essentialRefs = options.essentialRefs, _a = options.unsafe_strategy, closeStrategy = _a === void 0 ? 'pressdown' : _a;
    var optionsRef = useRef({ onClose: onClose, refs: essentialRefs, closeStrategy: closeStrategy });
    useEffect(function () {
        if (optionsRef.current.onClose !== onClose) {
            optionsRef.current.onClose = onClose;
        }
        if (optionsRef.current.refs !== essentialRefs) {
            optionsRef.current.refs = essentialRefs;
        }
    }, [onClose, essentialRefs]);
    useEffect(function () {
        if (visible) {
            var options_1 = optionsRef.current;
            // Возможно стоит вынести в параметры, но пока нет такой необходимости
            var manager_1 = OverlayManager.getInstance();
            manager_1.addOverlay(options_1);
            return function () {
                manager_1.removeOverlay(options_1);
            };
        }
        return;
    }, [visible]);
}
